import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import soundImg from "assets/img/sound.svg";
// import HomeIcon from "assets/img/home_icon.svg";
import Success from "assets/img/ok.svg";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import SavefolderImg from "assets/img/savefolderimg.svg";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import HomeIcon from "assets/svg/HomeIcon";
import "components/Layout/style.css";
import Toast from "components/Ui/Toast";
import Store from "_Store";
import ArrowBack from "@mui/icons-material/ArrowBack";

const WelcomeLayout = ({
  content,
  title,
  containImg,
  children,
  handleSubmit,
  buttonLabel,
  buttonDisabled,
  task,
  backToStartBtn,
  showInfo = true,
  isSubmit = true,
}) => {
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
  };
  const {
    state: {
      activeFarm,
    }
  } = React.useContext(Store);
  const [showToast, setShowToast] = useState(false);
  return (
    <>
      <div style={{ position: "relative" }}>
        <div className="butnaccueil">
          <button
            className="accueil"
            onClick={() => handleNavigate("/cahier-sheet")}
          >
            {/* <img src={HomeIcon} /> */}
            <ArrowBack />
            Retour
          </button>
          <button
            className="accueil"
            onClick={() => handleNavigate("/farms")}
          >
            {/* <img src={HomeIcon} /> */}
            <HomeIcon />
            Accueil
          </button>

          <p>{content} </p>

        </div>
        {showInfo && (
          <>
            <div className="fremimg">
              <div>
                <img src={containImg} />
              </div>
              <h3 className="mb-0">{title}</h3>
            </div>
            <Grid container spacing={2} className="information_form">
              <Grid item xs={2}>
                <img src={soundImg} />
              </Grid>
              <Grid item xs={10}>
                <b>Information</b>
                <br />
                <p>
                {task}
                </p>
              </Grid>
            </Grid>
          </>
        )}
        {children}
        <div className="questionPage flex justify-center">
          <Box
            sx={{
              background: "transparent",
              margin: "0",
              display: "flex",
              justifyContent: "space-between",
              placeItems: "center",
              p: 1,
              // bgcolor: "background.paper",
              borderRadius: 1,
            }}
          >

            {
              backToStartBtn && <>
                <Button
                  variant="outlined"
                  color="warning"
                  onClick={ backToStartBtn.onClick}
                >
                   <ArrowBack /> {backToStartBtn.label}
                </Button>
              </>
            }

            <Button
              style={{ marginLeft: "10px" }}
              variant="outlined"
              color="primary"
              disabled={buttonDisabled ? buttonDisabled : false}
              onClick={() => {
                handleSubmit(false);
              }}
            >
              {buttonLabel}
            </Button>
            <Toast open={showToast} handleClose={() => setShowToast(false)} />
          </Box>
        </div>
      </div>
    </>
  );
};

export default WelcomeLayout;
